// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	"use strict";

	// RIPPLES EFFECT
	function ripplesEffect(e) {
		var waves, d, x, y;

		if ($(this).find('.waves').length === 0) {
			$(this).prepend('<span class="waves"></span>');
		}

		waves = $(this).find('.waves');
		waves.removeClass('ripple');

		if (!waves.height() && !waves.width()) {
			d = Math.max($(this).outerWidth(), $(this).outerHeight());
			waves.css({ height: d, width: d });
		}

		x = e.pageX - $(this).offset().left - waves.width() / 2;
		y = e.pageY - $(this).offset().top - waves.height() / 2;

		waves.css({ top: y + 'px', left: x + 'px' }).addClass('ripple');
	};


	$('.btn, .ripples').on('click', ripplesEffect);



	// JavaScript code
	// Get the element you want to add the class to
	const myElement = document.getElementById("header");

	// Get the initial position of the element from the top of the document
	const elementOffsetTop = myElement.offsetTop;

	// Function to add or remove the class based on scrolling position
	function addClassAfterScroll() {
		if (window.pageYOffset >= elementOffsetTop) {
			myElement.classList.add("scrolled-nav");
		} else {
			myElement.classList.remove("scrolled-nav");
		}
	}

	// Function to check if the scroll has reached the top and remove the class
	function removeClassAtTop() {
		if (window.pageYOffset === 0) {
			myElement.classList.remove("scrolled-nav");
		}
	}

	// Add a scroll event listener to add class when scrolling down
	window.addEventListener("scroll", addClassAfterScroll);

	// Add a scroll event listener to remove class when scrolling back to top
	window.addEventListener("scroll", removeClassAtTop);





	class Slider {
		constructor(rangeElement, valueElement, options) {
			this.rangeElement = rangeElement
			this.valueElement = valueElement
			this.options = options

			// Attach a listener to "change" event
			this.rangeElement.addEventListener('input', this.updateSlider.bind(this))
		}

		// Initialize the slider
		init() {
			this.rangeElement.setAttribute('min', options.min)
			this.rangeElement.setAttribute('max', options.max)
			this.rangeElement.value = options.cur

			this.updateSlider()
		}

		// Format the money
		asMoney(value) {
			return '' + parseFloat(value)
				.toLocaleString('en-US', { maximumFractionDigits: 2 })
		}

		generateBackground(rangeElement) {
			if (this.rangeElement.value === this.options.min) {
				return
			}

			let percentage = (this.rangeElement.value - this.options.min) / (this.options.max - this.options.min) * 100
			return 'background: linear-gradient(to right, #475BEE, #3449E3 ' + percentage + '%, #C5CFDA ' + percentage + '%, #dee1e2 100%)'
		}

		updateSlider() {
			const sliderValue = parseFloat(this.rangeElement.value);
			const selectedOption = document.querySelector('input[name="options"]:checked').value;

			// Update the displayed money value
			this.valueElement.innerHTML = this.asMoney(sliderValue);

			// Check slider value and selected option to add "active" class to the appropriate element
			const advElement = document.querySelector('.adv');
			const maxElement = document.querySelector('.pro');
			const advElementCard = document.querySelector('.card-adv'); // Change '.adv' to '.card-adv'
			const maxElementCard = document.querySelector('.card-pro'); // Change '.pro' to '.card-pro'

			// Reset all classes
			advElementCard.classList.remove('active');
			maxElementCard.classList.remove('active');

			if (selectedOption === "1") {
				if (sliderValue >= 15000 && sliderValue < 45000) {
					advElementCard.classList.add('active');

				} else if (sliderValue >= 45000) {
					maxElementCard.classList.add('active');
				}
			} else if (selectedOption === "2") {
				if (sliderValue >= 15000 && sliderValue < 45000) {
					advElementCard.classList.add('active');
				} else if (sliderValue >= 45000) {
					maxElementCard.classList.add('active');
				}
			} else if (selectedOption === "3") {
				if (sliderValue < 15000) {
					advElementCard.classList.add('active');
				} else if (sliderValue >= 15000 && sliderValue < 45000) {
					advElementCard.classList.add('active');
				} else if (sliderValue >= 45000) {
					maxElementCard.classList.add('active');
				}
			} else if (selectedOption === "4") {
				if (sliderValue < 15000) {
					maxElementCard.classList.add('active');
				} else if (sliderValue >= 15000 && sliderValue < 45000) {
					maxElementCard.classList.add('active');
				} else if (sliderValue >= 45000) {
					maxElementCard.classList.add('active');
				}
			}

			if (sliderValue >= 15000 && sliderValue < 45000) {
				advElement.classList.add('active');
				maxElement.classList.remove('active');
			}
			else if (sliderValue >= 45000) {
				advElement.classList.remove('active');
				maxElement.classList.add('active');
			}

			// Update the slider background
			this.rangeElement.style = this.generateBackground(this.rangeElement.value);
		}


	}

	let rangeElement = document.querySelector('.range [type="range"]')
	let valueElement = document.querySelector('.range .range__value span')

	let options = {
		min: 2000,
		max: 75000,
		cur: 9500
	}

	if (rangeElement) {
		let slider = new Slider(rangeElement, valueElement, options)

		slider.init()
	}

	// Get the necessary elements
	const checkbox = document.getElementById('idChk-normal');
	const periodSpans = document.querySelectorAll('.period');
	const labelMonthly = document.getElementById('label-monthly');
	const labelYearly = document.getElementById('label-yearly');
	const pricesMonth = document.querySelectorAll('.price.month');
	const pricesYear = document.querySelectorAll('.price.year');

	// Function to toggle the visibility of prices
	function togglePrices(isYearly) {
		if (isYearly) {
			pricesMonth.forEach(price => price.classList.add('d-none'));
			pricesYear.forEach(price => price.classList.remove('d-none'));
		} else {
			pricesYear.forEach(price => price.classList.add('d-none'));
			pricesMonth.forEach(price => price.classList.remove('d-none'));
		}
	}



	// Add a change event listener to the checkbox
	// checkbox.addEventListener('change', function () {
	// 	// Check if the checkbox is checked
	// 	if (this.checked) {
	// 		// Update the text to "/ yearly" for all periodSpans
	// 		periodSpans.forEach(span => span.textContent = '/ yearly');

	// 		// Add "active" class to Yearly label and remove it from Monthly label
	// 		labelMonthly.classList.remove('active');
	// 		labelYearly.classList.add('active');

	// 		// Show Yearly prices and hide Monthly prices
	// 		togglePrices(true);
	// 	} else {
	// 		// Update the text back to "/ monthly" for all periodSpans
	// 		periodSpans.forEach(span => span.textContent = '/ monthly');

	// 		// Add "active" class to Monthly label and remove it from Yearly label
	// 		labelYearly.classList.remove('active');
	// 		labelMonthly.classList.add('active');

	// 		// Show Monthly prices and hide Yearly prices
	// 		togglePrices(false);
	// 	}
	// });






	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();


jQuery(document).ready(function ($) {
	// Adding Bootstrap Modal to WordPress Menu
	$('.launch-contact-modal').find('a').attr('data-bs-toggle', 'modal');
	$('.launch-contact-modal').find('a').attr('data-bs-target', '#exampleModal');
});


$(document).on('click', '.navbar-toggler', function () {
	// Check if the button is not collapsed (not having the 'collapsed' class)
	if (!$(this).hasClass('collapsed')) {
		// If not collapsed, add 'nav-is-toggled' class to the body
		$('body').addClass('nav-is-toggled');
	} else {
		// If collapsed, remove 'nav-is-toggled' class from the body
		$('body').removeClass('nav-is-toggled');
	}
});

// Add an event listener to .nav-link elements
$(document).on('click', '.nav-link', function () {
	// Remove the 'nav-is-toggled' class from the body
	$('body').removeClass('nav-is-toggled');

	// Close the Bootstrap menu using the 'collapse' method
	$('#navbar').collapse('hide');
});

// Add an event listener to the backdrop element
const closeDrop = document.getElementById("backdrop");
closeDrop.addEventListener("click", function () {
	// Remove the 'nav-is-toggled' class from the body
	$('body').removeClass('nav-is-toggled');

	// Close the Bootstrap menu using the 'collapse' method
	$('#navbar').collapse('hide');
});
